/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */

import {RestApiService} from "../../../rest-api.service";
import {UserDetailsRes} from '../../../../contracts/v0/cp';
import {Observable} from 'rxjs';
import {BaseCollectionModel} from '@yasc/yasc-material-components';

export class ApiV0Misc {
    segment = '/misc';
    crmSegment: string = '/misc';

    // @ts-ignore
    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
        this.crmSegment = v0.crmSegment + this.crmSegment
    }

    getDevelopers() {
        return this.rest.get<BaseCollectionModel<UserDetailsRes>>(
            `${this.segment}/developers`,
            BaseCollectionModel<UserDetailsRes>
        );
    }

    getSupportedCultures(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/Cultures`)
    }

    getColleagues(everyone: boolean = false): Observable<BaseCollectionModel<UserDetailsRes>> {
        return this.rest.get<BaseCollectionModel<UserDetailsRes>>(`${this.segment}/Colleagues?everyone=${everyone}`, UserDetailsRes)
    }


}
